import React from 'react'
import styles from './styles.module.scss'

export default function RadioButton({ item, name, className, isChecked, onChange, isDisabled }) {
  return (
    <label className={`${styles.container} ${className}`}>
      {item.label}
      <input
        disabled={isDisabled}
        type='radio'
        value={item.value}
        name={name}
        checked={isChecked}
        onChange={onChange}
      />
      <span className={styles.checkmark}></span>
    </label>
  )
}
